module.exports = __webpack_public_path__ + "img/1561943526.0fc555fe.jpg";